import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

import { OFFLINE_WRITE_MESSAGE } from "@/lib/connectivity";

function getOnlineState() {
  return typeof navigator === "undefined" || navigator.onLine;
}

export const ConnectivityBanner = () => {
  const [isOnline, setIsOnline] = useState(getOnlineState);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (isOnline) return null;

  return (
    <div
      role="status"
      className="fixed inset-x-0 top-0 z-[100] flex items-center justify-center gap-2 bg-amber-600 px-4 py-2 text-center text-sm font-medium text-white shadow-md"
    >
      <WifiOff className="size-4 shrink-0" aria-hidden="true" />
      <span>{OFFLINE_WRITE_MESSAGE}</span>
    </div>
  );
};
